export const setWarningNote = (name, isShown) => {
  localStorage.setItem(name, JSON.stringify(isShown));
};
export const getWarningNote = (name) => {
  return JSON.parse(localStorage.getItem(name));
};
